module.exports = __webpack_public_path__ + "img/data center-c.e02325c.svg";